import { $api } from "../generated/client";
import { useLoggedViewer } from "./use-logged-user";
import useShopSuspense from "./use-shop-suspense";

/**
 * Returns the current user's effective shop-member record (role +
 * warehouse/store scope). Suspends until the shop and the viewer are ready — no
 * flash of unrestricted UI before the role resolves.
 *
 * Reads `viewer`: the membership the backend resolved, a super admin's virtual
 * ADMIN included (BAB-3035), who never appears in the members list. The list
 * (members' emails included) is only fetched against a backend without it.
 */
export function useCurrentShopMember(shopId: string) {
  const { data: shop } = useShopSuspense(shopId);
  const { data: viewer } = useLoggedViewer();
  const { data: members } = $api.useQuery(
    "get",
    "/shops/{shopId}/members",
    { params: { path: { shopId } } },
    { enabled: !shop.viewer },
  );

  const member =
    shop.viewer ??
    (viewer?.id
      ? (members?.find((m) => m.userId === viewer.id) ?? null)
      : null);

  return { member };
}
